import { context } from 'cadenza/map/context';
import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import { PhotoLayerApi } from 'cadenza/api-client/photolayer-api';

import { LayerAction } from './layer-action';
import i18n from './layer-actions.properties';

export class TogglePhotos extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer);
    this.#map = options.map;
  }

  execute () {
    return new PhotoLayerApi(this.#map.get(MapProperty.ID), this._layer.get(LayerProperty.ID))
      .setPhotosActive(!isPhotoMasterLayer(this.#map, this._layer))
      .then(() => context(this.#map).pull());
  }

  get label () {
    return isPhotoMasterLayer(this.#map, this._layer) ? i18n('photoLayer.hidePhotos') : i18n('photoLayer.showPhotos');
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer && this._layer.get(LayerProperty.HAS_ATTACHMENTS);
  }

}

export function isPhotoMasterLayer (map, photoMasterLayer) {
  return context(map).layers.some((layer) => {
    return layer.getSource() && layer.getSource().get('masterlayer') === photoMasterLayer.get(LayerProperty.ID);
  });
}
